import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./Lendingapp.css";
import ServiceFooter from "../../ServiceFooter";
import Marquee from "react-marquee-slider";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { cardsData, keyFeaturesData, technologiesData } from "./data";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Lendingapp = () => {
  const [velocity, setVelocity] = useState(60);
  // const [isFlipped, setIsFlipped] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const updateVelocity = () => {
      if (window.innerWidth <= 480) {
        setVelocity(20); // Very slow for small mobile
      } else if (window.innerWidth <= 768) {
        setVelocity(30); // Slower for mobile
      } else if (window.innerWidth <= 1600) {
        setVelocity(40); // Moderate speed for tablets
      } else {
        setVelocity(60); // Default speed for larger screens
      }
    };

    updateVelocity();
    window.addEventListener("resize", updateVelocity);
    return () => window.removeEventListener("resize", updateVelocity);
  }, []);

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroTop = heroRef.current?.offsetTop || 0;

      if (scrollY > heroTop / 2) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [activeKeyIndex, setActiveKeyIndex] = useState(0);

  const handleKeyShow = (index) => {
    setActiveKeyIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // loan benefits
  const [isPrevLoanBenDisabled, setIsPrevLoanBenDisabled] = useState(true);
  const [isNextLoanBenDisabled, setIsNextLoanBenDisabled] = useState(false);

  const handleLoanBenChange = (LoanBenSwiper) => {
    setIsPrevLoanBenDisabled(LoanBenSwiper.isBeginning);
    setIsNextLoanBenDisabled(LoanBenSwiper.isEnd);
  };

  // components
  const [isPrevCompDisabled, setIsPrevCompDisabled] = useState(true);
  const [isNextCompDisabled, setIsNextCompDisabled] = useState(false);

  const handleCompChange = (CompSwiper) => {
    setIsPrevCompDisabled(CompSwiper.isBeginning);
    setIsNextCompDisabled(CompSwiper.isEnd);
  };

  // features
  const [isPrevFeatureDisabled, setIsPrevFeatureDisabled] = useState(true);
  const [isNextFeatureDisabled, setIsNextFeatureDisabled] = useState(false);

  const handleFeatureChange = (FeatureSwiper) => {
    setIsPrevFeatureDisabled(FeatureSwiper.isBeginning);
    setIsNextFeatureDisabled(FeatureSwiper.isEnd);
  };

  // steps
  const [isPrevStepsDisabled, setIsPrevStepsDisabled] = useState(true);
  const [isNextStepsDisabled, setIsNextStepsDisabled] = useState(false);

  const handleStepsChange = (StepsSwiper) => {
    setIsPrevStepsDisabled(StepsSwiper.isBeginning);
    setIsNextStepsDisabled(StepsSwiper.isEnd);
  };

  // type
  const [isPrevTypeDisabled, setIsPrevTypeDisabled] = useState(true);
  const [isNextTypeDisabled, setIsNextTypeDisabled] = useState(false);

  const handleTypeChange = (TypeSwiper) => {
    setIsPrevTypeDisabled(TypeSwiper.isBeginning);
    setIsNextTypeDisabled(TypeSwiper.isEnd);
  };

  const handleNext = () => {
    if (currentIndex < cardsData.length - 1) {
      setIsFlipped(true);
      setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
        setIsFlipped(false);
      }, 600);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setIsFlipped(true);
      setTimeout(() => {
        setCurrentIndex((prev) => prev - 1);
        setIsFlipped(false);
      }, 600);
    }
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Loan lending app development</title>

        <meta name="title" content="Loan lending app development" />
        <meta
          name="description"
          content="Are you ready to develop your loan lending app? Get started today and revolutionize the lending industry!"
        />

        <meta property="og:title" content="Loan lending app development" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/loan-lending-app-development"
        />
      </Helmet>

      <main className="ln-main">
        {/* hero */}
        <article className="ln-hero ln-mb-40">
          <h1 className="ln-hero-title">Loan Lending App Development</h1>
          <p className="ln-hero-subcontent">
            Step into banking sector with beleaf’s loan lending app development
            services
          </p>
          <div className="text-center">
            <button
              className="ln-btn"
              data-toggle="modal"
              data-target="#myModal"
            >
              Get Consultation Now
            </button>
          </div>

          <div
            className={`ln-hero-anime-wrap ${isScrolled ? "visible" : ""}`}
            // style={{ transform: `translateY(-${offset * 0.3}px)` }}
          >
            <div className="ln-hero-round-one-outer">
              <div className="ln-hero-round-one">
                <div className="ln-hero-round-two-outer">
                  <div className="ln-hero-round-two">
                    <span className="ln-hero-shade"></span>
                  </div>
                </div>
              </div>
            </div>

            <div className="ln-hero-anime-txt-wrap">
              <h4 className="ln-hero-anime-text">LOAN LENDING</h4>
              <Marquee
                className="ln-hero-anime-marquee"
                velocity={velocity}
                direction="rtl"
                resetAfterTries={200}
              >
                <li className="ln-marquee-list">RBI</li>
                <li className="ln-marquee-list">ICBC</li>
                <li className="ln-marquee-list">JPMorgan Chase & Co.</li>
                <li className="ln-marquee-list">Bank of America</li>
                <li className="ln-marquee-list">BNP Paribas</li>
                <li className="ln-marquee-list">Citigroup</li>
                <li className="ln-marquee-list">DBS</li>
                <li className="ln-marquee-list">Goldman Sachs</li>
                <li className="ln-marquee-list">Wells Fargo</li>
                <li className="ln-marquee-list">Morgan Stanley</li>
                <li className="ln-marquee-list">Truist Financial</li>
              </Marquee>
            </div>
            <div className="text-center">
              <img
                src={require("../../../image/lending/heroNew.webp")}
                alt="Loan lending app development"
                loading="lazy"
                className="ln-hero-img"
              />
            </div>
          </div>
        </article>

        {/* about */}
        <article className="ln-about ln-mb-100 primary__landing-content-container">
          <div className="ln-abt-head">
            <div className="row mx-0 ln-abt-head-row align-items-center">
              <div className="col-lg-6">
                <h3 className="ln-subtitle-50">
                  What is <span className="ln-span">Loan Lending App</span>{" "}
                  Development?
                </h3>
                <p className="ln-subcontent">
                  Loan lending app development has emerged as a game-changer in
                  the financial industry, Loan lending app development involves
                  creating digital platforms that allow users to borrow and lend
                  money securely through their smartphones. Whether it's
                  personal loans, business loans, or mortgage financing, a
                  well-designed loan lending app simplifies the entire loan
                  management process, making it more accessible and
                  user-friendly.
                </p>
                <button
                  className="ln-btn"
                  data-toggle="modal"
                  data-target="#myModal"
                >
                  Get Free Demo
                </button>
              </div>
              <div className="col-lg-6 text-center">
                <div className="ln-about-img">
                  <img
                    src={require("../../../image/lending/aboutNew.webp")}
                    alt="Loan lending app development"
                    loading="lazy"
                  />

                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="ln-abt-btn"
                  >
                    Know More{" "}
                    <span className="ln-abt-btn-arr">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="ln-abt-main">
            <div className="row mx-0 ln-gl-row">
              <div className="col-md-6">
                <h4 className="ln-subtitle-44">
                  Goal of <span className="ln-span">Lending App</span>{" "}
                  Development
                </h4>
              </div>
              <div className="col-md-6">
                <div className="ln-goal-content">
                  <p>
                    <span>
                      The goal of lending app development is to simplify the
                      lending process, reduce transaction costs, and make
                      borrowing and lending more accessible and transparent. By
                      integrating advanced technologies like AI, machine
                      learning, blockchain, and data analytics, lending
                      platforms are offering more efficient and innovative ways
                      to handle loans, repayments, and interest calculations.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* importance */}
        <article className="ln-imp primary__landing-content-container ln-mb-80">
          <h3 className="ln-subtitle-50 ln-imp-title">
            The <span className="ln-span">Importance</span> of Loan Lending Apps
          </h3>
          <p className="ln-subcontent ln-imp-content">
            The demand for loan lending app development has surged due to
            several key reasons. Let's explore why these apps are becoming a
            necessity.
          </p>

          <div className="row mx-0 ln-imp-row">
            <div className="col-lg-4">
              <div className="ln-imp-card-wrap">
                <div className="ln-imp-card imp-card-one">
                  <span>01</span>
                  <h5>Convenience for Borrowers & Lenders</h5>
                  <p>
                    Traditional lending involves several steps, including
                    paperwork, credit checks, and long processing times. Loan
                    lending apps eliminate the complexity, providing a fast and
                    convenient way for borrowers to apply for loans and for
                    lenders to evaluate requests and offer funds.
                  </p>
                </div>

                <div className="ln-imp-card imp-card-two">
                  <span>02</span>
                  <h5>Instant Loan Disbursements</h5>
                  <p>
                    In today’s fast-paced world, time is critical. Lending app
                    development enables real-time loan disbursements. With
                    automated systems for evaluating applications and processing
                    approvals, the time from loan application to disbursement
                    can be dramatically reduced.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 ln-imp-img-col">
              <div className="ln-imp-img-wrap">
                <img
                  src={require("../../../image/lending/importanceNew.webp")}
                  alt="Loan lending app development"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ln-imp-card-wrap">
                <div className="ln-imp-card imp-card-three">
                  <span>03</span>
                  <h5>Lower Interest Rates</h5>
                  <p>
                    Traditional financial institutions tend to charge high
                    interest rates on loans due to their operational overheads.
                    On the other hand, lending platforms built with loan lending
                    app development often have lower operational costs, enabling
                    them to offer more competitive interest rates.
                  </p>
                </div>

                <div className="ln-imp-card imp-card-four">
                  <span>04</span>
                  <h5>Improved Credit Scoring Systems</h5>
                  <p>
                    Lending app development integrates advanced technologies
                    like AI and machine learning to assess the creditworthiness
                    of users. Traditional credit scores may not always reflect
                    an individual’s true financial health, but advanced
                    algorithms can analyze various financial behaviors,
                    including income, spending patterns, and social signals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 ln-imp-img-col-mob">
              <div className="ln-imp-img-wrap ln-img-importanceNew">
                <img
                  src={require("../../../image/lending/importanceNew.webp")}
                  alt="Loan lending app development"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </article>

        {/* types */}
        <article className="ln-loan-types ln-mb-80">
          <div className="primary__landing-content-container">
            <div className="row mx-0 g-3">
              <div className="col-lg-6 col-xl-6">
                <h3 className="ln-subtitle-44 text-white">
                  Types of{" "}
                  <span className="ln-span">Lending App development </span> we
                  specialize in
                </h3>
              </div>
              <div className="col-lg-1 d-none d-xl-block"></div>
              <div className="col-lg-6 col-xl-5">
                <p className="ln-subcontent text-white">
                  At our company, we specialize in developing a wide range of
                  lending apps tailored to meet various business models and
                  customer needs. Here are the types of lending apps we develop.
                </p>
              </div>
            </div>

            <div className="ln_types_swiper">
              <Swiper
                className=" az-dev-swiper p-1"
                spaceBetween={30}
                slidesPerView={1}
                modules={[Navigation, A11y]}
                navigation={{
                  prevEl: ".ln-type-prev",
                  nextEl: ".ln-type-next",
                }}
                onSlideChange={handleTypeChange}
                onReachBeginning={() => setIsPrevTypeDisabled(true)}
                onReachEnd={() => setIsNextTypeDisabled(true)}
                onFromEdge={() => {
                  setIsPrevTypeDisabled(false);
                  setIsNextTypeDisabled(false);
                }}
                speed={500}
              >
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">P2P</h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Personal</h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Business </h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Microloan </h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Payday </h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Student </h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Car </h4>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div>
                    <h4 className="ln_type_title">Mortgage </h4>
                  </div>
                </SwiperSlide>
              </Swiper>

              {/* <div className="fd-step-btn-wrap ln_type_btn_wrap">
                <button
                  className={`ln-type-prev ${
                    isPrevTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevTypeDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isPrevTypeDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                  onClick={() => {
                    setIsFlipped(false); // Flip backward
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                <button
                  className={`ln-type-next ${
                    isNextTypeDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextTypeDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isNextTypeDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                  onClick={() => {
                    setIsFlipped(true); // Flip forward
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>

              <div className="ln_type_card_wrap">
                <div
                  className={`ln_type_card_outer ${isFlipped ? "flipped" : ""}`}
                >
                  <div className="ln_type_card_inner_front">
                    <div className="ln_ty_in_content_fr">
                      <img
                        src={require("../../../image/lending/type-img-one.webp")}
                        alt="Loan lending app development" loading="lazy"
                        className="ln_type_cd_img"
                      />
                      <h5 className="ln_type_cd_title">
                        Peer-to-Peer (P2P) Lending Apps
                      </h5>
                      <p className="ln_type_cd_content">
                        These apps connect individual lenders directly with
                        borrowers, bypassing traditional financial institutions.
                        They offer a platform where users can lend money to
                        others and earn interest.
                      </p>
                    </div>
                  </div>

                  <div className="ln_type_card_inner_back">
                    <div className="ln_ty_in_content_bk">
                      <img
                        src={require("../../../image/lending/type-img-two.webp")}
                        alt="Loan lending app development" loading="lazy"
                        className="ln_type_cd_img"
                      />
                      <h5 className="ln_type_cd_title">
                        Personal Loan Lending Apps
                      </h5>
                      <p className="ln_type_cd_content">
                        Personal loan apps allow users to apply for loans to
                        cover personal expenses like medical bills, education,
                        or home improvements. These apps typically feature quick
                        approval processes and flexible repayment plans.
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* new */}

              <div className="fd-step-btn-wrap ln_type_btn_wrap">
                <button
                  className={`ln-type-prev ${
                    currentIndex === 0 ? "disabled" : ""
                  }`}
                  style={{
                    color: currentIndex === 0 ? "#9747ff8a" : "#9747FF",
                    cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                  onClick={handlePrev}
                  disabled={currentIndex === 0}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                <button
                  className={`ln-type-next ${
                    currentIndex === cardsData.length - 1 ? "disabled" : ""
                  }`}
                  style={{
                    color:
                      currentIndex === cardsData.length - 1
                        ? "#9747ff8a"
                        : "#9747FF",
                    cursor:
                      currentIndex === cardsData.length - 1
                        ? "not-allowed"
                        : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                  onClick={handleNext}
                  disabled={currentIndex === cardsData.length - 1}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>

              <div className="ln_type_card_wrap">
                <div
                  className={`ln_type_card_outer ${isFlipped ? "flipped" : ""}`}
                >
                  <div className="ln_type_card_inner_front">
                    <div className="ln_ty_in_content_fr">
                      <img
                        src={cardsData[currentIndex].img}
                        alt="Loan lending app development"
                        loading="lazy"
                        className="ln_type_cd_img"
                      />
                      <h5 className="ln_type_cd_title">
                        {cardsData[currentIndex].title}
                      </h5>
                      <p className="ln_type_cd_content">
                        {cardsData[currentIndex].content}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* key features */}
        <article className="ln-key ln-mb-80">
          <div className="primary__landing-content-container">
            <h3 className="ln-subtitle-50 ln-key-title">
              <span className="ln-span">Key Features</span> of Loan Lending App
              Development
            </h3>
            <p className="ln-subcontent ln-key-content">
              A successful loan lending app development project must include
              essential features to ensure smooth functionality. Here are the
              must-have features.
            </p>

            <div className="row mx-0 ln-key-row align-items-center">
              <div className="col-lg-6">
                {keyFeaturesData.map((data, index) => {
                  return (
                    <div
                      key={data.id}
                      className={`ln-key-card-wrap ${
                        activeKeyIndex === index ? "active" : ""
                      }`}
                    >
                      <h6
                        className={`ln-key-card-title ${
                          activeKeyIndex === index ? "active" : ""
                        }`}
                        onClick={() => handleKeyShow(index)}
                      >
                        {data.title}
                      </h6>

                      {activeKeyIndex === index && (
                        <ul className="ln-key-card-list">
                          <li>{data.listOne}</li>
                          <li>{data.listTwo}</li>
                        </ul>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="col-lg-6 key_features_div">
                <img
                  src={require("../../../image/lending/keyNewImg.webp")}
                  alt="Loan lending app development"
                  loading="lazy"
                  
                />
              </div>
            </div>
          </div>
        </article>

        {/* technologies */}
        <article className="ln-tech primary__landing-content-container ln-mb-100">
          <div className="row mx-0 ln-tech-row-one">
            <div className="col-lg-6">
              <h3 className="ln-subtitle-44">
                Technologies Used in{" "}
                <span className="ln-span">Loan Lending App</span> Development
              </h3>
            </div>
            <div className="col-lg-6">
              <p className="ln-subcontent">
                To build a successful loan lending app development, developers
                must incorporate cutting-edge technologies that ensure
                performance, scalability, and security. Some of the essential
                technologies used in lending app development include
              </p>
            </div>
          </div>

          <div className="row mx-0 ln-tech-row-two g-4">
            {technologiesData.map((data) => {
              return (
                <div key={data.id} className="col-lg-4 col-sm-6">
                  <div className="ln-tech-card">
                    <div className="ln-tech-img-outer">
                      <div className="ln-tech-img-inner">
                        <img
                          src={data.icon}
                          alt="Loan lending app development"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <h5>{data.title}</h5>
                    <p>{data.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </article>

        {/* loan manage software */}
        <article className="ln-loan-mng primary__landing-content-container ln-mb-40">
          <div className="row mx-0 ln-loan-row">
            <div className="col-lg-6 ln-loan-lft-col">
              <h3 className="ln-subtitle-50 ln-loanmng-title">
                Loan <span className="ln-span">Management Software</span>{" "}
                Development
              </h3>
              <p className="ln-subcontent">
                Loan management software development plays a crucial role in
                automating and simplifying loan operations. It helps financial
                institutions efficiently handle loan origination, servicing,
                collections, and compliance.
              </p>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/lending/loanNewImg.webp")}
                alt="Loan lending app development"
                loading="lazy"
              />
            </div>
          </div>

          <img
            src={require("../../../image/lending/loan-lft.webp")}
            alt="Loan lending app development"
            loading="lazy"
            className="loan-lft"
          />
        </article>

        <article className="ln-loan-ben ln-mb-100">
          {/* loan benefits */}
          <div className="ln-loan-ben-one primary__landing-content-container">
            <h3 className="ln-subtitle-50 ln-loan-ben-title">
              Benefits of <span className="ln-span">Loan Management</span>{" "}
              Software
            </h3>

            <div className="mtr-process-swiper">
              <Swiper
                className="fd-step-swiper az-dev-swiper p-1"
                spaceBetween={30}
                slidesPerView={4}
                modules={[Navigation, A11y]}
                navigation={{
                  prevEl: ".ln-loan-ben-prev",
                  nextEl: ".ln-loan-ben-next",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleLoanBenChange}
                onReachBeginning={() => setIsPrevLoanBenDisabled(true)}
                onReachEnd={() => setIsNextLoanBenDisabled(true)}
                onFromEdge={() => {
                  setIsPrevLoanBenDisabled(false);
                  setIsNextLoanBenDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>01</span>
                    <p>
                      Automation of loan processing to reduce manual
                      intervention
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>02</span>
                    <p>
                      Improved risk assessment through AI and data analytics
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>03</span>
                    <p>
                      Faster disbursements for a seamless borrower experience
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>04</span>
                    <p>
                      Integration with credit bureaus for real-time credit score
                      analysis
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>05</span>
                    <p>
                      Regulatory compliance to adhere to financial industry
                      standards
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`ln-loan-ben-prev ${
                    isPrevLoanBenDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevLoanBenDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isPrevLoanBenDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`ln-loan-ben-next ${
                    isNextLoanBenDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextLoanBenDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isNextLoanBenDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* components */}
          <div className="ln-loan-ben-two primary__landing-content-container">
            <h3 className="ln-subtitle-50 ln-loan-ben-title">
              Components of <span className="ln-span">Loan Management</span>{" "}
              Software
            </h3>

            <div className="mtr-process-swiper">
              <Swiper
                className="fd-step-swiper az-dev-swiper p-1"
                spaceBetween={30}
                slidesPerView={4}
                modules={[Navigation, A11y]}
                navigation={{
                  prevEl: ".ln-loan-cmp-prev",
                  nextEl: ".ln-loan-cmp-nxt",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleCompChange}
                onReachBeginning={() => setIsPrevCompDisabled(true)}
                onReachEnd={() => setIsNextCompDisabled(true)}
                onFromEdge={() => {
                  setIsPrevCompDisabled(false);
                  setIsNextCompDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="ln-loan-component-card">
                    <h5>Loan Origination Module</h5>
                    <p>Automates the application and approval process.</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-component-card">
                    <h5>Loan Servicing Module</h5>
                    <p>
                      Manages repayments, collections, and borrower accounts.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-component-card">
                    <h5>Risk Assessment Tools </h5>
                    <p>
                      Uses AI to analyze borrower risk and predict defaults.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-component-card">
                    <h5>Payment Gateway Integration</h5>
                    <p>
                      Allows multiple payment options for seamless repayment.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-component-card">
                    <h5>Reporting & Analytics</h5>
                    <p>
                      Provides insights into loan performance and financial
                      trends.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`ln-loan-cmp-prev ${
                    isPrevCompDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevCompDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isPrevCompDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`ln-loan-cmp-nxt ${
                    isNextCompDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextCompDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isNextCompDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* loan origin software */}
        <article className="ln-org-software primary__landing-content-container ln-mb-40">
          <div className="row mx-0 ln-loan-row ln-org-row">
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/lending/originNewImg.webp")}
                alt="Loan lending app development"
                loading="lazy"
              />
            </div>
            <div className="col-lg-6 ln-loan-lft-col ln-org-lft-col">
              <h3 className="ln-subtitle-50 ln-loanmng-title">
                Loan <span className="ln-span">Origination Software</span>{" "}
                Development
              </h3>
              <p className="ln-subcontent">
                Loan origination software development focuses on streamlining
                the process of initiating and approving loans. It is a vital
                component of any lending ecosystem as it determines the
                efficiency of loan approval cycles.
              </p>
            </div>
          </div>

          <img
            src={require("../../../image/lending/loan-lft.webp")}
            alt="Loan lending app development"
            loading="lazy"
            className="loan-orgin-lft"
          />
        </article>

        <article className="ln-loan-ben ln-mb-100">
          {/* features */}
          <div className="ln-loan-ben-one primary__landing-content-container">
            <h3 className="ln-subtitle-50 ln_ft_title">
              Features of <span className="ln-span">Loan Origination</span>{" "}
              Software
            </h3>

            <div className="mtr-process-swiper">
              <Swiper
                className="fd-step-swiper az-dev-swiper p-1"
                spaceBetween={30}
                slidesPerView={4}
                modules={[Navigation, A11y]}
                navigation={{
                  prevEl: ".ln-ft-prev",
                  nextEl: ".ln-ft-next",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleFeatureChange}
                onReachBeginning={() => setIsPrevFeatureDisabled(true)}
                onReachEnd={() => setIsNextFeatureDisabled(true)}
                onFromEdge={() => {
                  setIsPrevFeatureDisabled(false);
                  setIsNextFeatureDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>01</span>
                    <p>Automated KYC & Document Verification</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>02</span>
                    <p>Instant Credit Risk Evaluation</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>03</span>
                    <p>Customizable Loan Approval Workflow</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>04</span>
                    <p>E-signature & Digital Documentation</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ln-loan-ben-card">
                    <span>05</span>
                    <p>
                      Integration with Third-Party APIs (Credit Bureaus, Banks,
                      and Payment Gateways)
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`ln-ft-prev ${
                    isPrevFeatureDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevFeatureDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isPrevFeatureDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`ln-ft-next ${
                    isNextFeatureDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextFeatureDisabled ? "#9747ff8a" : "#9747FF",
                    cursor: isNextFeatureDisabled ? "not-allowed" : "pointer",
                    border: "1px solid #ffffff4c",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* advantages */}
          <div className="ln-loan-ben-two primary__landing-content-container">
            <h3 className="ln-subtitle-50 ln-loan-ben-title">
              Advantages of <span className="ln-span">Loan Origination </span>{" "}
              Software
            </h3>

            <div className="row mx-0 g-4 ln_adv_row">
              <div className="col-lg-3 col-sm-6">
                <div className="ln-loan-component-card">
                  <h5>Faster Loan Processing</h5>
                  <p>Reduces the turnaround time for loan approvals.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="ln-loan-component-card">
                  <h5>Minimized Errors</h5>
                  <p>Automates manual tasks to prevent human errors.</p>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="ln-loan-component-card">
                  <h5>Enhanced Customer Experience</h5>
                  <p>
                    Provides a smooth and digital-first loan application
                    process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* steps */}
        <article className="ln-loan-steps primary__landing-content-container">
          <h3 className="ln-subtitle-50 ln-step-title">
            Steps to <span className="ln-span">Develop a Loan Lending </span>
            App
          </h3>
          <p className="ln-subcontent ln-step-content">
            Developing a loan lending app requires careful planning, execution,
            and testing to ensure it meets the needs of both lenders and
            borrowers. Below is a step-by-step process for loan lending app
            development.
          </p>

          <div className="mtr-process-swiper">
            <Swiper
              className="fd-step-swiper az-dev-swiper p-1"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y]}
              navigation={{
                prevEl: ".ln-steps-prev",
                nextEl: ".ln-steps-next",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleStepsChange}
              onReachBeginning={() => setIsPrevStepsDisabled(true)}
              onReachEnd={() => setIsNextStepsDisabled(true)}
              onFromEdge={() => {
                setIsPrevStepsDisabled(false);
                setIsNextStepsDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-one.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>Define Business Requirements</h5>
                  <ul>
                    <li>
                      Identify target users (individual borrowers, businesses,
                      financial institutions)
                    </li>
                    <li>
                      Choose the type of loans to be offered (personal, home,
                      business, etc.)
                    </li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-two.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>UI/UX Design</h5>
                  <ul>
                    <li>Create a user-friendly interface</li>
                    <li>Ensure mobile responsiveness</li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-three.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>Develop Core Features</h5>
                  <ul>
                    <li>Loan application & approval</li>
                    <li>Credit assessment integration</li>
                    <li>Repayment processing</li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-four.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>Integrate Security & Compliance</h5>
                  <ul>
                    <li>Implement encryption protocols</li>
                    <li>Ensure KYC and AML compliance</li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-five.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>Testing & Quality Assurance</h5>
                  <ul>
                    <li>Perform security and functionality testing</li>
                    <li>Optimize app performance</li>
                  </ul>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ln_step_card">
                  <div className="ln_step_img_wrap">
                    <img
                      src={require("../../../image/lending/step-img-six.webp")}
                      alt="Loan lending app development"
                      loading="lazy"
                    />
                  </div>

                  <h5>Deployment & Maintenance</h5>
                  <ul>
                    <li>Launch the app on iOS and Android</li>
                    <li>Provide regular updates and support</li>
                  </ul>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`ln-steps-prev ${
                  isPrevStepsDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevStepsDisabled ? "#9747ff8a" : "#9747FF",
                  cursor: isPrevStepsDisabled ? "not-allowed" : "pointer",
                  border: "1px solid #00000019",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`ln-steps-next ${
                  isNextStepsDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextStepsDisabled ? "#9747ff8a" : "#9747FF",
                  cursor: isNextStepsDisabled ? "not-allowed" : "pointer",
                  border: "1px solid #00000019",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Loan lending app development is transforming the financial
              industry by making loan services more accessible, efficient, and
              secure. Whether it's loan management software development, loan
              origination software development, or lending software development,
              each component plays a crucial role in creating a seamless lending
              experience for both lenders and borrowers. If you're looking to
              build a feature-rich lending solution, partnering with an
              experienced fintech development company is the key to success.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What technologies are used in loan lending app
                          development?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Common technologies include AI, blockchain, cloud
                          computing, and payment gateway integrations for secure
                          and efficient transactions.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Do loan lending apps support multiple currencies?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, many loan lending apps can be developed to
                          support multiple currencies, making them accessible
                          for global users.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Can a loan lending app be integrated with existing
                          systems?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, loan lending apps can be integrated with your
                          existing systems, like CRM or banking APIs, to
                          streamline processes and data management.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Is it possible to add a peer-to-peer lending feature?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, a peer-to-peer lending feature can be added,
                          allowing users to lend directly to others through the
                          app.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Lendingapp;
